module.exports = __webpack_public_path__ + "static/media/TUSD_BUSD_Biswap.44b6e996.png";